import type { RecommendationFrequency } from "@calega/content";

export const weekdays = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
export interface RecommendationPlanValue {
  frequency: RecommendationFrequency | "";
  weekStartsOn: number;
  recommendedMinutes: string;
}
export const emptyRecommendationPlan: RecommendationPlanValue = { frequency: "", weekStartsOn: 1, recommendedMinutes: "" };

export function recommendationPlanInput(value: RecommendationPlanValue) {
  const minutes = value.recommendedMinutes.trim() === "" ? null : Number(value.recommendedMinutes);
  if (minutes !== null && (!Number.isInteger(minutes) || minutes <= 0 || minutes > 2_147_483_647)) {
    throw new Error("Bitte eine positive ganze Minutenzahl eingeben oder das Feld leer lassen.");
  }
  return { frequency: value.frequency || null, weekStartsOn: value.frequency === "THREE_PER_WEEK" ? value.weekStartsOn : null, recommendedMinutes: minutes };
}

export function recommendationRhythm(frequency: RecommendationFrequency | null, weekStartsOn: number | null) {
  if (frequency === "DAILY") return "Täglich";
  if (frequency === "EVERY_TWO_DAYS") return "Alle 2 Tage nach der letzten Erledigung";
  if (frequency === "THREE_PER_WEEK") return `3 Übungstage pro Woche · ${weekdays[weekStartsOn!]} bis ${weekdays[(weekStartsOn! + 6) % 7]}`;
  return "Ohne festen Rhythmus";
}

export function RecommendationPlanFields({ value, onChange, progressEnabled = true }: {
  value: RecommendationPlanValue;
  onChange: (value: RecommendationPlanValue) => void;
  progressEnabled?: boolean;
}) {
  return <fieldset className="recommendation-plan-fields">
    <legend>Übungsplan</legend>
    <label>Wie oft?<select value={value.frequency} onChange={(event) => onChange({ ...value, frequency: event.target.value as RecommendationPlanValue["frequency"] })}>
      <option value="">Ohne festen Rhythmus</option>
      <option value="DAILY" disabled={!progressEnabled}>Täglich</option>
      <option value="EVERY_TWO_DAYS" disabled={!progressEnabled}>Alle 2 Tage</option>
      <option value="THREE_PER_WEEK" disabled={!progressEnabled}>3× pro Woche</option>
    </select></label>
    {!progressEnabled && <p className="muted">Wiederholungspläne benötigen das Modul Fortschritt.</p>}
    {value.frequency === "THREE_PER_WEEK" && <>
      <label>Die Übungswoche beginnt am<select value={value.weekStartsOn} onChange={(event) => onChange({ ...value, weekStartsOn: Number(event.target.value) })}>
        {[1, 2, 3, 4, 5, 6, 0].map((day) => <option key={day} value={day}>{weekdays[day]}</option>)}
      </select></label>
      <p className="muted">Bis einschließlich {weekdays[(value.weekStartsOn + 6) % 7]}. Es zählen drei verschiedene Übungstage. Der Plan beginnt sofort; die erste Übungswoche kann deshalb kürzer sein.</p>
    </>}
    {value.frequency === "EVERY_TWO_DAYS" && <p className="muted">Nach jeder Erledigung ist die nächste Einheit zwei Kalendertage später fällig.</p>}
    <label>Minuten pro Durchlauf (optional)<input type="number" min="1" step="1" inputMode="numeric" value={value.recommendedMinutes} onChange={(event) => onChange({ ...value, recommendedMinutes: event.target.value })} /></label>
    <p className="muted">Die Minuten dienen zur Orientierung. Die Übung wird dadurch weder begrenzt noch automatisch beendet.</p>
  </fieldset>;
}
